import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import parse from 'html-react-parser';

import Swal from 'sweetalert2';

import { Customer, } from '../../classess/customer/customer';
import { Parameter, } from '../../classess/parameter/parameter';
import { ParameterDetail } from '../../classess/parameter/parameterDetail';

import { GlobalFormats } from '../../classess/main/globalFormats';

import ParameterDetailAddEditDetail from './ParameterDetailAddEditDetail';

import {
    getProcessButtons, dataTableLanguaje, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, getRolesType, settings, styles, getUserRoles, LoadingSection, awaitDelayAsync,
    handleResponseMessageAsync,
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { Device } from '../../classess/device/device';
import { ParameterService } from '../../services/parameters/ParameterService';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, icons, images, labels, messages, timers } = settings;

const currentMethod = 'ParameterDetailsEdit';

export default function ParameterDetailsEdit({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const { type = '', id = '' } = useParams();
    const [viewType] = useState(type === labels?.edit?.en?.toLowerCase() ?
        1 :
        (type === labels?.details?.en?.toLowerCase() ? 2 : 0));
    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    let userRoles = getRolesType();
    userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod, })?.result;
    const dtParameterDetailsId = 'dtParameterDetails';
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: true,
        save: false,
        addDetail: false,
        edit: false,
        report: false,
        back: false,
    });
    const [devices, setDevices] = useState([Device?.getClass({}, false)]);
    const brdFieldViewsObj = {
        status: {
            label: '',
            badget: '',
        },
        scheduledDate: {
            date: '',
            time: ''
        },
        executionDate: {
            date: '',
            time: ''
        },
        commentary: '',
    };
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        reportShowModal: false,
        languageObj: languageObj,
        dtParameterDetailsId: dtParameterDetailsId,
        dtParameterDetailsRowId: 0,
        parameter: Parameter?.getClass({}, false),
        parameterDetail: ParameterDetail?.class({}, false),
        brdFieldViews: brdFieldViewsObj,
        devices: devices,
        setDevices: setDevices,
        userRoles: userRoles,
    });
    const controls = {
        buttons: {
            addDetail: {
                defaultClass: 'btn btn-info shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddParameter',
            },
            back: {
                defaultClass: 'btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary',
                id: 'btnBack',
            },
            edit: {
                defaultClass: 'btn btn-warning shadow-sm font-weight-bold mx-1 px-4 text-dark',
                id: 'btnEdit',
            },
            report: {
                defaultClass: 'btn btn-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnReport',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnSave',
            },
        },
        checkBoxs: {
            isActive: {
                id: 'chkIsActive',
                defaultClass: '',
            },
        },
        dataTables: {
            parameterDetails: {
                inputs: {
                    search: {
                        id: `${dtParameterDetailsId}_filter input`,
                        defaultClass: 'form-control form-control-sm bg-light border-0 shadow-sm ml-2',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtParameterDetailsId}_length select`,
                        defaultClass: '',
                    },
                },
                paginateds: {
                    paginated: {
                        id: `${dtParameterDetailsId}_paginate`,
                        defaultClass: '',
                    },
                },
                columns: {
                    process: {
                        id: 2,
                    },
                },
            },
        },
        icons: {
            addDetail: {
                id: 'iconAddDetail',
                defaultClass: icons?.fasFa?.list,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
            edit: {
                id: 'iconEdit',
                defaultClass: icons?.fasFa?.edit,
            },
            report: {
                id: 'iconReport',
                defaultClass: icons?.fasFa?.fileAlt,
            },
            save: {
                id: 'iconSave',
                defaultClass: icons?.fasFa?.save,
            },
        },
        inputs: {
        },
        pickers: {
        },
        selects: {
            customers: {
                id: 'selCustomer',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
        },
        spiners: {
            addDetail: {
                id: 'spAddDetail',
                defaultClass: '',
            },
            back: {
                id: 'spBack',
                defaultClass: '',
            },
            edit: {
                id: 'spEdit',
                defaultClass: '',
            },
            report: {
                id: 'spReport',
                defaultClass: '',
            },
            save: {
                id: 'spSave',
                defaultClass: '',
            },
        },
        textAreas: {
        }
    };
    const urlBack = `${backend?.urls?.parameters}/`;
    const [customers, setCustomers] = useState([Customer?.getClass({}, false)]);
    const [parameter, setParameter] = useState(Parameter?.getClass({}, false));
    const pFieldsViewObj = {
        parameter: {
            customer: {
                rif: '',
                name: '',
            },
            devices: 0,
        },
    };
    const [pFieldsView, setPFieldsView] = useState(pFieldsViewObj); //eslint-disable-line
    const [fields, setFields] = useState([]);
    const [errors, setErrors] = useState({ customer: '' });
    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    //#region parameter
    const editParameter = async ({
        e = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'editParameter';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let devicesData = [Device?.getClass({}, false)];
            let parameterData = Parameter?.getClass({}, false);
            let customersData = [Customer?.getClass({}, false)];
            let parameterDetailsData = [ParameterDetail?.class({}, false)];
            //#endregion variables

            e?.preventDefault?.();

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true, showLoading: true }));

            //#region edit (data)
            response = await ParameterService.update({
                auth: auth,
                id: parameter?.id,
                parameter: parameter,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;

            //#region set data
            customersData = response?.result?.customers?.sort((a, b) => a.name.toLowerCase().trim() > b.name.toLowerCase().trim() ? 1 : -1) || [];
            setCustomers(customersData);
            parameterData = response?.result?.parameter || {};
            setParameter(parameterData);
            parameterDetailsData = response?.result?.parameterDetails || [];
            devicesData = response?.result?.devices || [];
            setDevices(devicesData);
            //#endregion set data
            //#endregion edit (data)

            $(`#${dtParameterDetailsId}`)?.DataTable()?.rows()?.clear()?.draw(true);

            //#region set datatable
            if ((!isUndNullEmp({ data: parameterDetailsData, subMethod: currentMethod })?.result && parameterDetailsData.length > 0) ||
                (!isUndNullEmp({ data: devicesData, subMethod: currentMethod })?.result && devicesData.length > 0)) {
                response = setDataInDataTable({
                    parameterDetails: parameterDetailsData,
                    devices: devicesData,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
            }
            //#endregion set datatable

            response = getResponse({
                type: 0,
                msgText: `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, save: false, showLoading: false, }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const getParameterReport = async ({
        e = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getParameterReport';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, report: true, showLoading: true }));

            //#region get data (parameter report)
            response = await ParameterService.getReportPdfAsync({
                auth: auth,
                id: parameter?.id,
                dateFrom: '',
                dateTo: '',
                languageCode: languageObj?.code,
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion get data (parameter report)

            window.open(response?.result, '_blank', 'noopener,noreferrer');
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, report: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion parameter

    //#region parameterdetails
    const getParameterDetailAdd = async ({
        e = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getParameterDetailAdd';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region check role
            if (!userRoles?.isAdmin && !userRoles?.isAnalyst) {
                response = getResponse({
                    type: 1,
                    msgText: `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`
                });
                return;
            }
            //#endregion check role

            //#region check data
            if ((parameter?.id || 0) <= 0) {
                response = getResponse({
                    type: 1,
                    msgText: `<b>id</b>: ${messages?.itIsRequired?.[languageObj?.id]}.`
                });
                return;
            }
            //#endregion check data

            setProcess(prev => ({ ...prev, addDetail: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond, });

            //#region set data
            setModalObj(prev => ({
                ...prev,
                parameter: parameter,
                parameterDetail: {
                    ...ParameterDetail?.class({}, false),
                    parameterId: parameter?.id,
                    register: new Date().toISOString(),
                },
                devices: devices,
                showModal: true,
                type: 0,
            }));
            //#endregion set data
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, addDetail: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const getParameterDetailEditDetail = async ({
        e = {},
        id = 0,
        description = '',
        rowId = 0,
        type = 1,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getParameterDetailEditDetail';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            const brdFieldViews = { ...brdFieldViewsObj };
            let devicesData = [];
            let parameterDetailData = ParameterDetail?.class({}, false);
            //#endregion variables

            e?.preventDefault?.();

            //#region check role
            if (userRoles?.isAnonymous) {
                response = getResponse({
                    type: 1,
                    msgText: `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`
                });
                return;
            }
            //#endregion check role

            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region parameterdetail (get byid)
            response = await ParameterService.getDetailById({
                auth: auth,
                id: id,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return

            devicesData = response?.result?.devices || [];
            setDevices(devicesData);
            parameterDetailData = response?.result?.parameterDetail || {};
            //#endregion parameterdetail (get byid)

            //#region check data
            if (isUndNullEmp({ data: parameterDetailData, subMethod: currentMethod })?.result) {
                response = getResponse({
                    type: 1,
                    msgText: `${messages?.theRecordCannotBeLocated[languageObj?.id]}<br/><b>${description}</b><br/>`
                });
                return response;
            }
            //#endregion check data

            //#region set data
            setModalObj(prev => ({
                ...prev,
                dtParameterDetailsRowId: rowId,
                parameter: parameter,
                parameterDetail: parameterDetailData,
                brdFieldViews: brdFieldViews,
                showModal: true,
                devices: devicesData,
                type: type,
            }));
            //#endregion set data
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const deleteParameterDetail = async ({
        e = {},
        id = 0,
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'deleteParameterDetail';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            //#endregion variables

            e?.preventDefault?.();

            //#region show message
            let msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.parameterDetail?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };
            const swalProperties = {
                icon: settings?.react?.sweetAlert2?.messages?.types?.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                showConfirmButton: !Swal.isLoading(),
                confirmButtonColor: settings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: settings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete data (parameterdetail)
                        preConfirmResponse = await ParameterService.deleteDetail({
                            auth: auth,
                            id: id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (country)

                        //#region delete datatable (country)
                        $(`#${dtParameterDetailsId}`)?.DataTable().row(rowId).remove()?.draw(true);
                        //#endregion delete datatable (country)

                        preConfirmResponse = getResponse({
                            type: 0,
                            msgText: `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`
                        });
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire({ ...swalProperties });
            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion parameterdetails

    //#region others
    const getData = async ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region check type (url)
            if (viewType !== 1 && viewType !== 2) {
                window.location.href = `${backend?.urls?.notFound}`;
                return;
            }
            //#endregion check type (url)

            if (!auth?.isLoged({ subMethod: currentMethod })?.result) {
                setShowData(false);
                window.location.href = urlBack;
                return;
            }

            //#region datatable (set)
            response = setDataTables({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion datatable (set)

            //#region set query code
            response = setQueryCode({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set query code

            //#region check role
            if (viewType === 1 && !userRoles?.isAdmin && !userRoles?.isAnalyst) {
                response = getResponse({
                    type: 1,
                    msgText: `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`,
                    urlGoTo: urlBack,
                });
                return;
            }
            //#endregion check role

            //#region check data
            if (isUndNullEmp({ data: id, subMethod: currentMethod })?.result) {
                response = getResponse({
                    type: 1,
                    msgText: `${labels?.parameter?.[languageObj?.id]}. ${messages?.itIsRequired[languageObj?.id]}.`,
                    urlGoTo: urlBack,
                });
                return;
            }
            //#endregion check data

            //#region get data (parameter)
            response = await ParameterService.getById({
                auth: auth,
                id: id,
                withDetails: true,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            //#region set data
            let customersData = response?.result?.customers?.sort((a, b) => a.name.toLowerCase().trim() > b.name.toLowerCase().trim() ? 1 : -1) || [];
            setCustomers(customersData);
            let customerData = response?.result?.customer || {};

            let parameterData = response?.result?.parameter || {};
            setParameter(parameterData);
            let parameterDetailsData = response?.result?.parameterDetails || [];
            let devicesData = response?.result?.devices || [];
            setDevices(devicesData);
            //#endregion set data

            //#region check data
            if (isUndNullEmp({ data: parameterData, subMethod: currentMethod })?.result) {
                response = getResponse({
                    type: 1,
                    msgText: `${messages?.theRecordCannotBeLocated[languageObj?.id]}.<br/>`,
                    urlGoTo: urlBack,
                });
                return;
            }
            //#endregion check data
            //#endregion get data (parameter)

            //#region field views (set)
            if (viewType === 2) {
                response = setFieldViews({
                    _parameter: parameterData,
                    _parameterDetails: parameterDetailsData,
                    _customer: customerData,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
            }
            //#endregion field views (set)

            //#region set datatable
            if (parameterDetailsData.length > 0 || devicesData.length > 0) {
                response = setDataInDataTable({
                    parameterDetails: parameterDetailsData,
                    devices: devicesData,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
            }
            //#endregion set datatable
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            response.urlGoTo = urlBack;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const goToBack = async ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'goToBack';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            //#endregion variables

            setProcess(prev => ({ ...prev, back: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond, });

            window.location.href = urlBack;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, back: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const goToEdit = async ({
        e = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'goToEdit';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, edit: true, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond, });

            window.location.href = `${backend?.urls?.parameters}/${labels?.edit?.en?.toLowerCase()}/${parameter?.id || 0}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, edit: false, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setFieldViews = ({
        _parameter = {},
        _parameterDetails = [],
        _customer = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setFieldViews';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let _fieldsViewObj = { parameter: { ...pFieldsViewObj?.parameter } };
            let fieldsData = [];
            //#endregion variables

            if (!isUndNullEmp({ data: _parameter, subMethod: currentMethod })?.result &&
                _parameter?.id > 0) {
                //#region variables
                const modelCustomer = Customer?.getClass(_customer, false);
                //#endregion variables

                _fieldsViewObj.parameter.customer.rif = modelCustomer?.rif;
                _fieldsViewObj.parameter.customer.name = `${modelCustomer?.rif || ''} - ${modelCustomer?.name || ''}`;
                _fieldsViewObj.parameter.devices = _parameterDetails?.length;

                setPFieldsView(_fieldsViewObj);

                fieldsData = [
                    { label: labels?.customer?.[languageObj?.id], value: _fieldsViewObj?.parameter?.customer?.name || '---', icon: icons?.fasFa?.user, color: 'primary' },
                    { label: labels?.devices?.[languageObj?.id], value: _fieldsViewObj?.parameter?.devices || 0, icon: icons?.fasFa?.server, color: 'info' },
                ];
                setFields(fieldsData);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            //#region backup reviews
            $(`#${dtParameterDetailsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.device[languageObj?.id], width: '20%', orderable: false, },
                    { title: labels?.description?.[languageObj?.id], width: '75%', orderable: false, },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                //order: [[0, 'asc'], [1, 'asc']],
                order: [[0, 'asc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtParameterDetailsId}_wrapper .col-md-6:eq(0)`);
            //#endregion backup reviews
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id_ = '';
            let methodName = '';
            let description = '';
            let rowId = 0;
            //#endregion variables

            //#region process
            //#region backup review details
            $(`#${dtParameterDetailsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowId = getDtRowIndex({ dtId: dtParameterDetailsId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id_ = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getParameterDetailEditDetail({ e: e, id: parseInt(id_), description: description, rowId: rowId, type: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            getParameterDetailEditDetail({ e: e, id: parseInt(id_), description: description, rowId: rowId, type: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            deleteParameterDetail({ e: e, id: parseInt(id_), description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion backup review details
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        parameterDetails = [],
        devices = [],
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let rowData = [];
            let processButtons = [];
            //#endregion variables

            //#region process
            //#region parameterdetails
            parameterDetails.forEach((parameterDetail) => {
                //#region variables
                const modelParameterDetail = ParameterDetail?.class(parameterDetail, false);
                let modelDevice = Device?.getClass({}, false);
                modelDevice = devices?.filter(({ id, }) => id === (parameterDetail?.deviceId || 0))[0] || {};
                processButtons = [];
                //#endregion variables

                rowData.push([
                    modelDevice?.name || '',
                    modelParameterDetail?.description || '',
                    getProcessButtons({
                        id: modelParameterDetail.id,
                        description: modelDevice?.name || '',
                        showDetails: true,
                        labelDetails: labels?.details?.[languageObj?.id],
                        enabledDetails: true,
                        showDelete: (userRoles?.isAdmin || userRoles?.isAnalyst) && viewType === 1,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: (userRoles?.isAdmin || userRoles?.isAnalyst) && viewType === 1,
                        showEdit: (userRoles?.isAdmin || userRoles?.isAnalyst) && viewType === 1,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: (userRoles?.isAdmin || userRoles?.isAnalyst) && viewType === 1,
                        processButtons: processButtons,
                    })?.result,
                ]);
            });

            $(`#${dtParameterDetailsId}`)?.DataTable()?.rows?.add(rowData)?.draw(true);
            //#endregion parameterdetails
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors(prev => ({ ...prev, customer: '' }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const validateFormData = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            //#endregion variables

            //#region method
            if (isUndNullEmp({ data: parameter, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, customer: `${messages?.thisFieldRequired?.[languageObj?.id]}.` }));
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmp({ data: parameter?.customerId, subMethod: currentMethod })?.result ||
                parseInt(parameter?.customerId) <= 0) {
                setErrors(prev => ({ ...prev, customer: `${messages?.thisFieldRequired?.[languageObj?.id]}.` }));
                response = getResponse({ type: 1 });
            }
            //#endregion method
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={app?.views?.services?.services}
                process={app?.views?.parameters?.parameters} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>
                                    {viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}
                                </h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={urlBack}>{labels?.parameters?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={settings?.html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadinSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.parameter?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.parameters} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.parameter?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className={`badge badge-pill ${viewType === 1 ? 'badge-warning' : 'badge-info'} px-2 py-1 text-uppercase`} style={settings?.html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.list} mr-1`}></i> {viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4'>
                                                {/* Toolbar */}
                                                <div className='d-flex flex-wrap justify-content-end align-items-center mb-4' style={{ gap: '8px' }}>
                                                    <button id={controls?.buttons?.save?.id}
                                                        className={controls?.buttons?.save?.defaultClass}
                                                        disabled={viewType !== 1 || process?.showLoading || process?.save}
                                                        hidden={viewType !== 1}
                                                        onClick={(e) => editParameter({ e: e, subMethod: controls?.buttons?.save?.id, })}
                                                        style={{ borderRadius: '5px' }}
                                                        type='button'>
                                                        {process?.save ? (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        ) : (
                                                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.defaultClass} />
                                                        )} {labels?.save?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.addDetail?.id}
                                                        className={controls?.buttons?.addDetail?.defaultClass}
                                                        disabled={viewType !== 1 || (parameter?.id || 0) <= 0 || process?.showLoading || process?.addDetail}
                                                        hidden={viewType !== 1}
                                                        onClick={(e) => getParameterDetailAdd({ e: e, subMethod: e?.currentTarget?.id })}
                                                        style={{ borderRadius: '5px' }}
                                                        type='button'>
                                                        {process?.addDetail ? (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        ) : (
                                                            <i id={controls?.icons?.addDetail?.id} className={controls?.icons?.addDetail?.defaultClass} />
                                                        )} {labels?.addDetail?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.edit?.id}
                                                        className={controls?.buttons?.edit?.defaultClass}
                                                        disabled={viewType !== 2 || (!userRoles?.isAdmin && !userRoles?.isAnalyst) || process?.showLoading || process?.edit}
                                                        hidden={viewType !== 2 || (!userRoles?.isAdmin && !userRoles?.isAnalyst)}
                                                        onClick={(e) => goToEdit({ e: e, subMethod: controls?.buttons?.edit?.id, })}
                                                        style={{ borderRadius: '5px' }}
                                                        type='button'>
                                                        {process?.edit ? (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        ) : (
                                                            <i id={controls?.icons?.edit?.id} className={controls?.icons?.edit?.defaultClass} />
                                                        )} {labels?.edit?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.report?.id}
                                                        className={controls?.buttons?.report?.defaultClass}
                                                        disabled={viewType !== 2 || parameter?.id <= 0 || process?.showLoading || process?.report}
                                                        hidden={viewType !== 2}
                                                        onClick={(e) => getParameterReport({ e: e, subMethod: e?.currentTarget?.id, })}
                                                        style={{ borderRadius: '5px' }}
                                                        type='button'>
                                                        {process?.report ? (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        ) : (
                                                            <i id={controls?.icons?.report?.id} className={controls?.icons?.report?.defaultClass} />
                                                        )} {labels?.report?.[languageObj?.id]}
                                                    </button>
                                                    <button id={controls?.buttons?.back?.id}
                                                        className={controls?.buttons?.back?.defaultClass}
                                                        disabled={process?.showLoading || process?.back}
                                                        style={{ borderRadius: '5px' }}
                                                        type='button'
                                                        onClick={() => goToBack({ subMethod: controls?.buttons?.back?.id })}>
                                                        {process?.back ? (
                                                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                        ) : (
                                                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.defaultClass} />
                                                        )} {labels?.back?.[languageObj?.id]}
                                                    </button>
                                                </div>

                                                {/* Form/Details Content */}
                                                {viewType === 1 ?
                                                    <form onSubmit={(e) => e?.preventDefault()}>
                                                        <div className='row'>
                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group'>
                                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={icons?.fasFa?.user} /> {labels?.customer?.[languageObj?.id]}
                                                                    </small>
                                                                    <select id={controls?.selects?.customers?.id}
                                                                        className={controls?.selects?.customers?.defaultClass}
                                                                        style={{ borderRadius: '5px' }}
                                                                        value={!isUndNullEmp({ data: parameter?.customerId, subMethod: controls?.selects?.customers?.id, })?.result ?
                                                                            parameter?.customerId : `0`
                                                                        }
                                                                        disabled={process?.showLoading}
                                                                        onChange={(e) => setParameter(prev => ({ ...prev, customerId: parseInt(e?.target?.value) }))}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, customer: '' }))}>
                                                                        <option key={`nothing`} value={`0 text-muted`}>{messages?.selectCustomer?.[languageObj?.id]}</option>
                                                                        {customers?.map((customer) => <option key={customer.id} value={customer.id}>{customer.name}</option>)}
                                                                    </select>
                                                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.customer)}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                    :
                                                    <div className='row'>
                                                        {fields.map((field, idx) => (
                                                            <div key={idx} className={`col-12 col-md-${field.wide ? '12' : '6'} mb-3`}>
                                                                <div className={`p-3 rounded bg-light border-left border-${field.color || 'primary'} shadow-sm h-100`}
                                                                    style={{ borderLeftWidth: '5px' }}>
                                                                    <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                                                        style={settings?.html?.labels?.detailMicro}>
                                                                        {field.icon && <i className={`${field.icon} mr-1`} />} {field.label}
                                                                    </small>
                                                                    <span className='text-dark font-weight-bold'>{field.value || '---'}</span>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                }

                                                <hr className='my-4' />
                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.list} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.details?.[languageObj?.id]}</h6>
                                                </div>

                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className={settings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                            <table id={dtParameterDetailsId} className={settings?.html?.dataTables?.formats?.tableHoverW100Border0} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-footer bg-white border-top-0 pb-4 px-4'>
                                            </div>
                                        </div>

                                    ) : (
                                        <div ></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className='text-center py-5'>
                                <i className={`${icons?.fasFa?.lock} fa-3x text-muted mb-3`}></i>
                                <h3 className='text-muted'>{messages?.accessDenied?.[languageObj?.id]}</h3>
                            </div>
                        )}

                    </div>
                </section>

            </div>

            {modalObj?.showModal && (
                <ParameterDetailAddEditDetail modalObj={modalObj}
                    setModalObj={setModalObj} />
            )}
        </div>
    )
}